import React from 'react';
import { Button, Col, FormGroup, Input, Label, Modal, Row, Table } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import Logger from 'utils/logger';
import { requestPut } from 'utils/fetchHelper';
import { isValidResponse } from 'utils/responseValidChecker';
import CompanyFilter from 'views/components/searchFilter/CompanyFilter';
import UserTypeFilter from 'views/components/searchFilter/UserTypeFilter';
import { handleCopyClick } from 'views/components/alert/toastAlert/copy';

// 관리자 수정 모달
@inject('user', 'searchFilter', 'miniAlertModal', 'loader', 'toastAlert')
@observer
class ModifyUserModal extends React.Component {
  toggleModal = () => {
    const { user, searchFilter } = this.props;
    user.set('modifyModalIsOpen', !user.modifyModalIsOpen);
    searchFilter.setUserTypeList('select');
  };

  // 수정 버튼 클릭 이벤트 처리
  handleSubmitButtonClick = () => {
    const { user, miniAlertModal } = this.props;
    // 빈 항목이 있는지 체크
    if (user.editUser.loginId === '' || user.editUser.name === '') {
      miniAlertModal.show('빈 항목이 있습니다.');
      return false;
    }

    this.fetchModifyUser();
  };

  // 관리자 수정 API 처리
  fetchModifyUser = async () => {
    const { user, searchFilter, miniAlertModal, loader, fetchRefresh } = this.props;
    loader.show(true);

    const url = process.env.REACT_APP_ENDPOINT + `/v1/admin/api/users/${user.editUser.id}`;
    const body = {
      ...user.editUser,
      phone: user.editUser.phone.replaceAll('-', ''),
      companyId: searchFilter.selectCompany.value,
      userType: searchFilter.selectUserType.value,
      ipAddress: user.editUser.ipAddress.length > 0 ? user.editUser.ipAddress.split(',') : []
    };
    const responseData = await requestPut(url, body);
    loader.show(false);
    await isValidResponse(responseData, miniAlertModal, this.props.history);

    if (responseData.code === '0000') {
      this.toggleModal();
      user.clearModifyUser();
      await searchFilter.set('page', 1);
      fetchRefresh();
      searchFilter.setUserTypeList('select');
      miniAlertModal.show('수정되었습니다.');
    } else {
      miniAlertModal.show(responseData.message);
    }
  };

  render() {
    const { user, fetchRefresh, toastAlert } = this.props;
    return (
      <Modal className="modal-lg" backdrop={'static'} isOpen={user.modifyModalIsOpen} toggle={this.toggleModal}>
        <div className="modal-header justify-content-center">
          <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={this.toggleModal}>
            <i className="nc-icon nc-simple-remove" />
          </button>
          <h4 className="title title-up">유저 수정</h4>
        </div>
        <div className="modal-body __paddingModalBody __modalScrollbar">
          <Row>
            <Col md="12" className="text-right">
              <div className="__inline-div">
                <Label
                  className="label-page"
                  style={{ color: 'black', cursor: 'pointer' }}
                  onClick={(e) => {
                    let mousePosition = { mouseX: e.clientX, mouseY: e.clientY };
                    handleCopyClick(toastAlert, `${user.whatIsMyIp}`, mousePosition);
                  }}
                >
                  내 IP: {user.whatIsMyIp}
                </Label>
                <input
                  id={`${user.whatIsMyIp}`}
                  value={user.whatIsMyIp}
                  readOnly
                  style={{position: 'absolute', top: -999, left: -999}}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Table bordered>
                <thead>
                  <tr className="text-center">
                    <th width="25%">회사명 *</th>
                    <th width="25%">아이디 *</th>
                    <th width="25%">임시 비밀번호 *</th>
                    <th width="25%">이름 *</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <CompanyFilter refreshData={fetchRefresh} />
                    </td>
                    <td>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="loginId"
                          value={user.editUser.loginId}
                          onChange={e => {
                            user.setEditUser('editUser', 'loginId', e.target.value);
                          }}
                          disabled
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="password"
                          name="password"
                          value={user.editUser.password}
                          onChange={e => {
                            user.setEditUser('editUser', 'password', e.target.value);
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="name"
                          value={user.editUser.name}
                          onChange={e => {
                            user.setEditUser('editUser', 'name', e.target.value);
                          }}
                        />
                      </FormGroup>
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr className="text-center">
                    <th width="25%">이메일</th>
                    <th width="25%">전화번호</th>
                    <th colSpan={2} width="50%">
                      권한 *
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="email"
                          value={user.editUser.email}
                          onChange={e => {
                            user.setEditUser('editUser', 'email', e.target.value);
                            user.setRegisterUser('email', e.target.value);
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="phone"
                          value={user.editUser.phone}
                          onChange={e => {
                            user.setEditUser('editUser', 'phone', e.target.value);
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td colSpan={2}>
                      <UserTypeFilter />
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr className="text-center">
                    <th colSpan={2} width="50%">
                      IP 주소
                    </th>
                    <th colSpan={2} width="50%">
                      마지막 로그인 일시
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="ipAddress"
                          value={user.editUser.ipAddress}
                          onChange={e => {
                            user.setEditUser('editUser', 'ipAddress', e.target.value);
                          }}
                        />
                      </FormGroup>
                    </td>
                    <td colSpan={2}>
                      <FormGroup>
                        <Input
                          className="__textAlignCenter __inline-input"
                          type="text"
                          name="lastLoggedAt"
                          value={user.editUser.lastLoggedAt}
                          disabled
                        />
                      </FormGroup>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <div className="left-side">
            <Button
              className="btn-link"
              color="info"
              data-dismiss="modal"
              type="button"
              onClick={this.handleSubmitButtonClick}
            >
              수정
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side">
            <Button className="btn-link" color="danger" type="button" onClick={this.toggleModal}>
              닫기
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

ModifyUserModal.defaultProps = {
  fetchRefresh: async () => {
    Logger.log('[ModifyApModal] - refresh function is undefined');
  }
};

export default ModifyUserModal;
